import {
  AnyAction,
  createListenerMiddleware,
  isAnyOf,
  ListenerMiddlewareInstance,
  ThunkDispatch,
  UnsubscribeListener,
} from '@reduxjs/toolkit';

import { AppRootState } from '../../../store/models/app-state.model';
import { CampaignReportsListenerEffect } from '../effects/campaign-reports-listener.effect';
import {
  addPagination,
  resetPagination,
  setCampaignId,
} from '../store/slices/campaign-reports.slice';

export const campaignReportsListener: ListenerMiddlewareInstance<
  AppRootState,
  ThunkDispatch<AppRootState, undefined, AnyAction>
> = createListenerMiddleware();

export const unsubscribeAppsFilterListener: UnsubscribeListener =
  campaignReportsListener.startListening({
    matcher: isAnyOf(setCampaignId, addPagination, resetPagination),
    effect: CampaignReportsListenerEffect,
  });
